import React, { useEffect, useState } from "react";
import { Table, Button } from "antd"; // Import Button from Ant Design

function TeaStallDetails({ allData }) {
  console.log(allData)
  const [data, setData] = useState([]);
  // const [expandedRows, setExpandedRows] = useState({}); // State to manage visibility of data per shop

  useEffect(() => {
    setData(allData);
  }, [allData]);

  // Define columns for the main tea stall details table
  const teaStallColumns = [
    {
      title: "Name",
      dataIndex: ["shop", "name"],
      key: "name",
    },
    {
      title: "Working Days",
      dataIndex: ["shop", "workingDays"],
      key: "workingDays",
    },
    {
      title: "Cup Count",
      dataIndex: ["shop", "cupCount"],
      key: "cupCount",
    },
    {
      title: "Selling Price per Cup",
      dataIndex: ["shop", "sellingPricePerCup"],
      key: "sellingPricePerCup",
    },
    {
      title: "Cup Consumption",
      dataIndex: ["shop", "cupConsumption"],
      key: "cupConsumption",
    },
  ];

  // Define columns for the materials table
  const materialColumns = [
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Prcie",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
    },
    {
      title: "Raw Material",
      dataIndex: "rawMaterial",
      key: "rawMaterial",
    },
    {
      title: "Created At",
      dataIndex: "created",
      key: "created",
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        {data && data.length > 0 ? (
          data.map((shopData, index) => (
            <div key={index} className="col-12 mb-4">
                <h5 className="mb-2">{shopData?.shop?.name}</h5>
                <p className="mb-1">Working Days: {shopData?.shop?.workingDays}</p>
                <p className="mb-1">Cup Count: {shopData?.shop?.cupCount}</p>
                <p className="mb-1">Selling Price: {shopData?.shop?.sellingPricePerCup}</p>
                <p className="mb-1">Cup Consumption: {shopData?.shop?.cupConsumption}</p>
              <div className="card shadow-sm">
                <div className="card-body">

                  {shopData.materials && shopData.materials.length > 0 && (
                    <div className="table-responsive mt-4">
                      <h6>Materials:</h6>
                      <Table
                        dataSource={shopData.materials}
                        columns={materialColumns}
                        pagination={false}
                        rowKey={(record) => record.quantity + record.price + record.totalAmount} // Unique key for each material
                      />
                      {/* {shopData.materials.length > 3 && (
                        <Button
                          onClick={() => setExpandedRows((prev) => ({
                            ...prev,
                            [index]: !prev[index]
                          }))}
                          className="mt-2"
                        block>
                          {expandedRows[index] ? 'Show Less' : 'View All'}
                        </Button>
                      )} */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12">
            <div className="card text-center">
              <div className="card-body">
                <p className="text-muted">No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TeaStallDetails;
